import request from '@/router/axios'

export function dictList(query) {
  return request({
    url: '/dist/dict/list',
    method: 'get',
    params: query,
  })
}

export function areaList(level) {
  return request({
    url: '/dist/area/list/' + level,
    method: 'get',
  })
}

//配置接口
//字典管理
//接口：/dist/dict/*
//权限：dist_dict_*
export function getConfig(code) {
  return request({
    url: '/dist/dict/page',
    method: 'get',
    params: {
      code,
    },
  })
}

export function editConfig(data) {
  return request({
    url: '/dist/dict',
    method: 'put',
    data,
  })
}
